<template>
  <div class="download page">
    <!-- <app-bar class="f-s-16" color="#333" background="#FFF" nomenu>
      <div slot="title">赚钱了</div>
    </app-bar> -->
    <img width="100%" src="../assets/img/zql/register/banner_top.png" alt srcset />
    <div class="activity-item">
      <div class="card">
        <div class="user-msg d-flex align-item-center">
            <img width="50" class="user-head" :src="invitor.ico ? invitor.ico : require('../assets/img/icon_defaulthead.png')" alt="">
            <div class="user-name d-flex flex-column t-left">
                <div class="f-s-16 c-black-3">{{invitor.alias}}</div>
                <div class="f-s-14 c-black-9">邀请您来 <span class="c-black-3">赚钱了</span></div>
            </div>
        </div>
        <img class="m_line" src="../assets/img/zql/download/m_line2.png" alt="">
        <div class="tips f-s-14 c-black-3">下载APP，您最高可得88元红包。 </div>
        <div class="step-list d-flex justify-space-between">
          <div class="step-list-item">
            <div class="num">1</div>
            <div class="text f-s-14 c-black-3">下载赚钱了</div>
          </div>
          <div class="step-list-item">
            <div class="num">2</div>
            <div class="text f-s-14 c-black-3">手机号注册</div>
          </div>
          <div class="step-list-item">
            <div class="num">3</div>
            <div class="text f-s-14 c-black-3">邀请好友</div>
          </div>
        </div>
        <div class="button-line">
          <a :href="href">下载APP</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import  "https://i.zql100.com/cg/downUrl.js";
// import appBar from "../components/appBar"
export default {
  components: {
    // appBar
  },
  data() {
    return {
      invitor: {},
      href: ''
    }
  },
  methods: {
    simpleInfo() {
      this.$axios.get("/user/simpleInfo", {
        params: {
          id: this.$route.query.id
        }
      })
      .then(res => {
        if (res.code === 200 && res.data) {
          this.invitor = res.data
        }
      })
    }
  },
  created() {
    this.simpleInfo();
    this.href = `https://i.zql100.com/downLoad.html?appId=${this.$route.query.appId}&v=${(Math.random() * 1000).toFixed()}`
  }
}
</script>

<style lang="less" scoped>
.page{
  height: 100%;
  overflow: auto;
  background:linear-gradient(0deg,rgba(255,99,27,1) 0%,rgba(254,107,29,1) 68%,rgba(255,97,52,1) 84%,rgba(254,163,14,1) 100%);
  >img{
    margin-bottom: -60%;
  }
  .activity-item{
    position: relative;
    .card{
      // position: absolute;
      // top: 51%;
      // left: 4vw;
      // right: 4vw;
      // padding: 7.4vw;
      // background:rgba(255,255,255,1);
      // border-radius:6px;
      // margin-bottom: 45px;
      .user-msg{
        .user-name{
          margin-left: 12px;
        }
      }
      .m_line{
        width: 50%;
        margin: 25px 0 15px;
      }
      .step-list{
        .step-list-item{
          margin: 26px auto 16px;
          flex-grow: 1;
          position: relative;
          .num{
            position: relative;
            width: 18px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            margin: 0 auto 8px;
            background: #FFD3CA;
            color: #FF4622;
            border-radius: 50%;
            z-index: 1;
          }
          &::after{
            content: ' ';
            position: absolute;
            top: 9px;
            height: 1px;
            background: #FFD3CA;
            left: 50%;
            right: 0;
          }
          &::before{
            content: ' ';
            position: absolute;
            top: 9px;
            height: 1px;
            background: #FFD3CA;
            left: 0;
            right: 50%;
          }
          &:last-child::after,&:first-child::before{
            display: none;
          }
        }
      }
      .button-line{
        margin: 16px 0 18px;
        display: flex;
        justify-content: space-between;
        a{
          width: 100%;
          padding: 6px 0;
          height: 38px;
          box-sizing: border-box;
          color: #FFF;
          font-size: 16px;
          border-radius: 100px;
          color: #fff;
          text-decoration: none;
          background:linear-gradient(90deg,rgba(254,170,0,1) 0%,rgba(255,209,5,1) 100%);
        }
      }
      a{
        font-weight: 600;
        font-size: 16px;
        color: #FF4622;
        text-decoration: underline;
      }
    }
  }
}
</style>